module.exports = __webpack_public_path__ + "static/img/car3d.8179432.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/car3d.png
// module id = RPcv
// module chunks = 1